import styled from 'styled-components'

export const ContentList = styled.div`
  display: flex;
  flex-wrap: nowrap;
  max-width: 100%;
  min-width: 100%;
  overflow-x: scroll;
  padding: 0 0 14px 0;
  position: relative;
  scroll-snap-type: x mandatory;
  gap: 16px;

  > div {
    scroll-snap-align: start;
  }

  @media (min-width: ${(p) => p.theme.breakpoints.md}) {
    overflow-x: hidden;
  }
`

export const PreviousButton = styled.div`
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  align-items: center;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.3) 30%,
    rgba(0, 0, 0, 0) 100%
  );
  cursor: pointer;
  display: none;
  justify-content: center;
  max-height: calc(100% - 12px);
  min-height: calc(100% - 12px);
  min-width: 40px;
  opacity: 1;
  position: absolute;
  top: 0;
  transition: all 0.4s;
  z-index: 999;

  @media (min-width: ${(p) => p.theme.breakpoints.md}) {
    display: flex;
  }
`

export const NextButton = styled(PreviousButton)`
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.3) 30%,
    rgba(0, 0, 0, 0) 100%
  );
  right: 0;
`

export const ListContainer = styled.div`
  max-width: 100%;
  min-width: 100%;
  position: relative;
  z-index: 0;
`
